/**
 * Business 页 data —— 占位（具体 sections 待 CD 出稿后填充）
 * noindex：领导决定只让 Google 收录 Home + Pro
 */
import type { PageData } from '@/content/types';

export const data: PageData = {
  seo: {
    title: 'LoEvent Business',
    description: 'Built for teams that turn events into predictable revenue channels.',
    ogImage: '/images/ogimage.jpg',
    index: false,
  },
  sections: [
    {
      type: 'hero',
      data: {
        headline: 'LoEvent Business',
        subheadline: 'Built for teams that turn events into predictable revenue channels.',
        cta: { label: 'Get Started', href: 'https://app.loevent.com/business' },
      },
    },
    {
      type: 'cta-band',
      data: {
        title: 'Talk to us',
        body: 'Custom pricing for teams of 5+',
        cta: { label: 'Contact Sales', href: 'mailto:sales@loevent.com' },
      },
    },
  ],
};
